import React, { useEffect, useMemo, useState } from "react"
import { Card, CardBody, Col, Row, Button, Input, Table } from "reactstrap"

// assume you already have this
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
import { useNavigate } from "react-router-dom"
import Select from "react-select"
import NoImg from "../../../assets/images/Payroll management/PunchDetails.jpg"
import { fetchNodeData, FetchNodePostData, FetchNodePutData } from "utils/common-fetchData"
import secureLocalStorage from "react-secure-storage"
import { DigitalServiceOptionsDrop } from "utils/common-options"
import moment from "moment" 
import SeoReportPreview from "./FinalReport"
import Loader from "pages/Separate/Loader"

export function getYearOptions(till = 2010) {
  const yearsOptions = []
  for (let year = new Date().getFullYear(); year >= till; year--)
    yearsOptions.push(year)

  return yearsOptions
}

function formatKeywordsData(data = []) {
  const result = {}
  const totalMonths = data.length

  data.forEach((item, index) => {
    const monthKey = `month${index + 1}`
    const keywords = JSON.parse(item.keyword)

    keywords.forEach(({ keyword, rank }) => {
      const cleanKeyword = keyword.trim()

      if (!result[cleanKeyword]) {
        result[cleanKeyword] = {
          keyword: cleanKeyword,
          months: {},
          progress: null,
        }
      }

      result[cleanKeyword].months[monthKey] = Number(rank)
    })
  })

  // 🔥 calculate progress (last 2 months)
  Object.values(result).forEach(item => {
    const monthKeys = Object.keys(item.months)
    if (monthKeys.length < 2) return

    const lastKey = monthKeys[monthKeys.length - 1]
    const prevKey = monthKeys[monthKeys.length - 2]

    const lastRank = item.months[lastKey]
    const prevRank = item.months[prevKey]

    if (lastRank != null && prevRank != null) {
      let status = '';
      if (lastRank == prevRank) status = "minus";
      if ((lastRank != 0 && lastRank < prevRank) || (prevRank == 0 && lastRank > prevRank)) status = "up";
      if ((prevRank != 0 && lastRank > prevRank) || (lastRank == 0 && prevRank > lastRank)) status = "down";

      item.progress = status;
      // item.progress = (lastRank == prevRank ? "minus" : (lastRank < prevRank || (prevRank == 0 && lastRank > prevRank)) ? "up" : "down")
    }
  })

  return Object.values(result)
}

export const monthOptions = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]

const monthDatesOptions = [
  {
    label: "Create new +",
    value: "Create new +",
  },
]


const performanceComparisonList = [
  {
    metric: "Total Website Visits",
    current: "",
    last: "",
    percentage: "",
    trend: "", // up / down
    fixed: true,
  },
  {
    metric: "Organic Traffic",
    current: "",
    last: "",
    percentage: "",
    trend: "",
    fixed: true,
  },
  {
    metric: "Direct Traffic",
    current: "",
    last: "",
    percentage: "",
    trend: "",
    fixed: true,
  },
  {
    metric: "Referral Traffic",
    current: "",
    last: "",
    percentage: "",
    trend: "",
    fixed: true,
  },
  {
    metric: "Time Spent on Site",
    current: "",
    last: "0",
    percentage: "",
    trend: "",
    fixed: true,
  },
]

const SeoReport = ({ isFinalReport = false, heading = "Seo Report" }) => {
  const [projectOptions, setProjectOptions] = useState([])
  const [project, setProject] = useState(null)
  const [service, setService] = useState(null)

  /* ================= 1. REPORT SUMMARY ================= */
  const [reportSummary, setReportSummary] = useState("<p></p>")

  /* ================= 2. KEY CHALLENGES ================= */
  const [challenges, setChallenges] = useState("<p></p>")

  /* ================= 3. KEY HIGHLIGHTS ================= */
  const [highlights, setHighlights] = useState([""])

  /* ================= 4. PERFORMANCE – ORDERS ================= */
  const [ordersPerformance, setOrdersPerformance] = useState({
    totalOrders: { title: "Total Orders", value: "", subtitle: "", reason: "" },
    totalOrderValue: {
      title: "Total Order Value",
      value: "",
      subtitle: "",
      reason: "",
    },
    avgOrderValue: {
      title: "Avg Order Value",
      value: "",
      subtitle: "",
      reason: "",
    },
  })

  /* ================= 5. CAMPAIGN PERFORMANCE ================= */
  const [campaigns, setCampaigns] = useState([
    { title: "", description: "", link: null },
  ])

  /* ================= 6. Local SEO PERFORMANCE ================= */
  const [localSeoPerformance, setLocalSeoPerformance] = useState([
    {
      google_buisness: "",
      interactions: "",
      calls: "",
      directions: "",
      Click: "",
      link: null,
    },
  ])

  /* ================= 7. KEYWORD POSITION SUMMARY ================= */
  const [keywordSummary, setKeywordSummary] = useState("<p></p>")
  const [keywords, setKeywords] = useState([])

  const [extraKeywords, setExtraKeywords] = useState([])

  const [monthlyKeywordRecords, setMonthlyKeywordRecords] = useState([
    {
      label: "Create new +",
      value: "Create new +",
    },
  ])

  const [performanceComparison, setPerformanceComparison] = useState([
    {
      metric: "Total Website Visits",
      current: "",
      last: "0",
      percentage: "",
      trend: "", // up / down
      fixed: true,
    },
    {
      metric: "Organic Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Direct Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Referral Traffic",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
    {
      metric: "Time Spent on Site",
      current: "",
      last: "0",
      percentage: "",
      trend: "",
      fixed: true,
    },
  ])

  /* ================= 8. NEXT STEPS ================= */
  const [nextSteps, setNextSteps] = useState("<p></p>")
  const [isCreated, setIsCreated] = useState("pending")

  const lastMonthDate = new Date();
  lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

  const [month, setMonth] = useState(lastMonthDate.getMonth() + 1); // if Jan = 1
  const [year, setYear] = useState(lastMonthDate.getFullYear());

  const [reportDate, setReportDate] = useState({})

  const [isOrders, setIsOrders] = useState(false)
  const [loading, setLoading] = useState(false)
  const [previewModal, setPreviewModal] = useState(false)
  const [allMonthKeywords, setAllMonthKeywords] = useState({})
  const [customerData, setCustomerData] = useState({})

  const [finalReportData, setFinalReportData] = useState({})
  const [dataIds, setDataIds] = useState({
    local_seo_id: "",
    web_traffic_id: "",
    performance_report_id: "",
    keyword_ranking_id: "",
    campaigns_id: ""
  })
  const [reportId, setReportId] = useState(null)
  const [isPublished, setIsPublished] = useState(false)
  const [isEditingContent, setIsEditingContent] = useState(false)

  const navigate = useNavigate()

  const token = secureLocalStorage.getItem("token")

  console.log("monthlyKeywordRecords", monthlyKeywordRecords)
  // ================= API CALLING ===================
  // get projects list
  useEffect(() => {
    ; (async () => {
      try {
        const projectsRes = await fetchNodeData(
          null,
          `seoReport/getProjectKS`,
          token
        )

        setProjectOptions(
          (projectsRes.data || []).map(item => ({
            value: item.id,
            label: item.project_name,
            services: DigitalServiceOptionsDrop.filter(
              s =>
                (item.project_type || "")?.includes(s.value) &&
                (s.value == "1" || s.value == "3")
            ),
            seo_keywords: item.seo_keywords || "",
          }))
        )
      } catch (error) {
        console.log("Error Calling API : ", error)
      }
    })()
  }, [])

  // set keywords projectwise
  useEffect(() => {
    if (project) {
      setKeywords(
        project.seo_keywords
          ?.split(",")?.filter(k => k)
          ?.map(keyword => ({ keyword: keyword, rank: "" })) || []
      )
      if (!isFinalReport && service) handleSearchReport()
    }
  }, [project])

  // set keywords data based on selected report date
  useEffect(() => {
    if (!isFinalReport) {
      if (reportDate.additional || reportDate?.keyword) {
        // console.log(reportDate)
        setExtraKeywords(JSON.parse(reportDate?.additional))
        setKeywords(JSON.parse(reportDate?.keyword))
      } else {
        setExtraKeywords([])
        setKeywords(
          project?.seo_keywords
            ?.split(",")
            ?.map(keyword => ({ keyword: keyword, rank: "" })) || []
        )
      }
    }
  }, [reportDate])

  // search Report Data
  const handleSearchReport = async e => {
    if (e) e.preventDefault()

    if (!project?.value || !service) {
      swal("", "Please Select Project and Service!", "warning")
      return
    }

    if (
      year >= new Date().getFullYear() &&
      month - 1 >= new Date().getMonth()
    ) {
      swal("", "Month and Year for Current or Future not allowed!", "warning")
      return
    }


    try {
      const formData = {
        id: project.value,
        year,
        month,
      }
      // For final report only
      if (isFinalReport) {
        const res = await fetchNodeData(
          setLoading,
          `seoReport/getFinalReport/${project.value}/${month < 10 ? `0${month}` : month}/${year}`,
          token,
          formData
        )
        if (res?.data?.publishedReport) {
          setIsPublished(true)
        } else {
          setIsPublished(false)
        }

        if (isEditingContent)
          setIsEditingContent(false)

        if (res?.data?.report && res?.message === "Fetched Report") {
          setReportId(res?.data?.report.id)
          const {
            report_summary,
            challenges,
            keyword_position_summary,
            next_steps,
            highlights
          } = res.data.report

          const { local_seo, keywords, prevTrafficData, currentWebTraffic,
            performance: performanceReport, sixMonthsKeywords, customer_info, website_url } = res.data

          const fields = ["visits", "organic", "direct", "referral", "time_spent"];
          let performance = []
          if (prevTrafficData || currentWebTraffic) {
            performance = performanceComparisonList.map((item, i) => {
              return updateTraffic(item, currentWebTraffic[fields[i]],
                (prevTrafficData ? prevTrafficData[fields[i]] : 0))
            })
          }

          const tempData = {
            reportSummary: report_summary,
            challenges: challenges,
            keywordSummary: keyword_position_summary,
            nextSteps: next_steps,
            ordersPerformance: {
              totalOrders: {
                title: "Total Orders",
                value: performanceReport?.totalOrders || "",
                subtitle: performanceReport?.totalOrders_subtitle || "",
                reason: performanceReport?.totalOrders_neg_reason || "",
              },
              totalOrderValue: {
                title: "Total Order Value",
                value: performanceReport?.totalOrderValue || "",
                subtitle: performanceReport?.totalOrderValue_subtitle || "",
                reason: performanceReport?.totalOrderValue_neg_reason || "",
              },
              avgOrderValue: {
                title: "Avg Order Value",
                value: performanceReport?.avgOrderValue || "",
                subtitle: performanceReport?.avgOrderValue_subtitle || "",
                reason: performanceReport?.avgOrderValue_neg_reason || "",
              }
            },
            highlights: JSON.parse(highlights),
            performanceComparison: performance,
            localSeoPerformance: local_seo || [],
          }

          if (performanceReport?.totalOrders || performanceReport?.totalOrderValue ||
            performanceReport?.avgOrderValue) {
            setIsOrders(true)
          }

          setReportSummary(tempData.reportSummary)
          setChallenges(tempData.challenges)
          setKeywordSummary(tempData.keywordSummary)
          setNextSteps(tempData.nextSteps)
          setHighlights(tempData.highlights)
          setOrdersPerformance(tempData.ordersPerformance)
          setPerformanceComparison(tempData.performanceComparison)


          setLocalSeoPerformance(tempData.localSeoPerformance)

          if (keywords.length) {
            setExtraKeywords(
              JSON.parse(keywords[0]?.additional || "[]")
            )
            setKeywords(JSON.parse(keywords[0]?.keyword || "[]"))
          }

          // multiple months keywords
          const columns = sixMonthsKeywords?.map((item, index) => ({
            key: `month${index + 1}`,
            label: moment(item.date).format("MMM YYYY"),
          }))

          const allmonthdata = formatKeywordsData(
            sixMonthsKeywords || []
          )

          setAllMonthKeywords({
            columns,
            data: allmonthdata,
          })

          setCustomerData(customer_info || {})

          // keeping published data in final report
          tempData.reportSummary = res?.data?.publishedReport?.report_summary
          tempData.challenges = res?.data?.publishedReport?.challenges
          tempData.keywordSummary = res?.data?.publishedReport?.keyword_position_summary
          tempData.nextSteps = res?.data?.publishedReport?.next_steps
          tempData.highlights = JSON.parse(res?.data?.publishedReport?.highlights || "[]")
          setFinalReportData(tempData)

          setIsCreated("create")
          return
        }

        else if (res?.message === "Fetched Presubmittion Report data.") {
          const { local_seo, webTraffic, previousWebTraffic, performanceReport, keywordRanking, campaingData } = res.data;
          setReportId(null)
          setIsPublished(false)
          setReportSummary("<p></p>")
          setChallenges("<p></p>")
          setKeywordSummary("<p></p>")
          setNextSteps("<p></p>")
          setHighlights([""])

          if (performanceReport?.totalOrders || performanceReport?.totalOrderValue ||
            performanceReport?.avgOrderValue) {
            setIsOrders(true)
            setOrdersPerformance({
              totalOrders: {
                title: "Total Orders",
                value: performanceReport?.totalOrders || "",
                subtitle: performanceReport?.totalOrders_subtitle || "",
                reason: performanceReport?.totalOrders_neg_reason || "",
              },
              totalOrderValue: {
                title: "Total Order Value",
                value: performanceReport?.totalOrderValue || "",
                subtitle: performanceReport?.totalOrderValue_subtitle || "",
                reason: performanceReport?.totalOrderValue_neg_reason || "",
              },
              avgOrderValue: {
                title: "Avg Order Value",
                value: performanceReport?.avgOrderValue || "",
                subtitle: performanceReport?.avgOrderValue_subtitle || "",
                reason: performanceReport?.avgOrderValue_neg_reason || "",
              }
            })
          }

          const fields = ["visits", "organic", "direct", "referral", "time_spent"];
          if (webTraffic) {
            setPerformanceComparison(
              performanceComparisonList.map((item, i) => {
                return updateTraffic(item, webTraffic[fields[i]],
                  (previousWebTraffic ?
                    previousWebTraffic[fields[i]] : 0))
              })
            )
          }
          // if (local_seo?.length)
          setLocalSeoPerformance(local_seo || [])

          setKeywords(JSON.parse(keywordRanking?.keyword || "[]") || [])
          setExtraKeywords(JSON.parse(keywordRanking?.additional || "[]") || [])

          setCustomerData({})
          setDataIds({
            local_seo_id: local_seo?.map(i => i.id)?.toString(),
            web_traffic_id: webTraffic?.id,
            performance_report_id: performanceReport?.id,
            keyword_ranking_id: keywordRanking?.id,
            campaigns_id: campaingData?.map(i => i.id)?.toString(),
          })

          if (local_seo?.length || keywordRanking?.keyword || webTraffic)
            setIsCreated("create")
        }
      }
      // ==============================

      const res = await FetchNodePostData(
        setLoading,
        `seoReport/searchKeywordRanking`,
        token,
        formData
      )

      const isPast =
        new Date(year, month - 1) <
        new Date(new Date().getFullYear(), new Date().getMonth())

      if (res.data.success) {
        setIsCreated(res.data.data.length ? "create" : "notfound")
        const options = [
          ...(res.data.data || []).map(
            record =>
            ({
              ...record,
              label: moment(record.date).format("DD MMMM"),
              value: record.date,
            } || [])
          ),

          ...((!res.data.data.length && isPast) || !isPast
            ? [monthDatesOptions[0]]
            : []),
        ]
        setMonthlyKeywordRecords(options.reverse())

        if (options.length > 1 && isFinalReport) {
          setReportDate(options[1])
        } else setReportDate(options[0])

        // if (options.length > 1)
        //   setReportDate(isFinalReport ? options[1] : monthDatesOptions[0])
        // else setReportDate(monthDatesOptions[0])
      }
    } catch (error) {
      console.log(error)
      swal("", "Something Went Wrong!", "error")
    }
  }

  // save keywords ranking
  const handleSaveKeywordRanking = async e => {
    // e.preventDefault()
    if (
      keywords.some(item => !item.rank) ||
      extraKeywords.some(item => item.keyword && !item.rank) ||
      extraKeywords.some(item => !item.keyword && !item.rank)
    ) {
      swal("", "Ranking for all keywords is required.", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to save keyword ranking for ${project?.label}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const endOfMonth = moment({ year, month: month - 1 })
            .endOf("month")
            .format("YYYY-MM-DD")

          const formData = {
            id: project.value,
            keywordRanking: JSON.stringify(keywords),
            additionalKeyword: JSON.stringify(extraKeywords),
            date:
              new Date(endOfMonth) < new Date()
                ? endOfMonth
                : moment().format("YYYY-MM-DD"),
          }
          const res = await FetchNodePostData(
            setLoading,
            `seoReport/addKeywordRanking`,
            token,
            formData
          )

          if (res?.data?.success) {
            handleSearchReport()
            swal("", "Ranking recorded successfully", "success")
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          console.log(res)

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  // Save Report data
  const saveFinalReport = async e => {
    if (
      !localSeoPerformance.length ||
      localSeoPerformance.some(item => {
        return (
          !item.google_buisness.trim() ||
          !item.interactions.trim() ||
          !item.calls.trim() ||
          !item.directions.trim() ||
          !item.Click.trim() ||
          !item.link
        )
      })
    ) {
      swal("", "Local SEO Data is missing!", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: isPublished ? `This report already been pubished. you still want to make changes request for ${monthOptions[month - 1]}, ${year}` :
        `You want to save report for ${monthOptions[month - 1]}, ${year}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        // e.preventDefault()
        try {
          const formData = {
            project_id: project.value,
            report_month: month,
            report_year: year,
            report_summary: reportSummary,
            challenges: challenges,
            keyword_position_summary: keywordSummary,
            next_steps: nextSteps,
            highlights: JSON.stringify(highlights),
            service_id: service?.value,
            performance: dataIds.performance_report_id,
            local_seo: dataIds.local_seo_id,
            // campaigns: dataIds.campaigns_id,
            keywords: dataIds.keyword_ranking_id,
            traffic: dataIds.web_traffic_id,
          }
          let res;
          if (reportId) {
            res = await FetchNodePutData(
              setLoading,
              `seoReport/editFinalReport`,
              reportId,
              formData
            )
          } else {
            res = await FetchNodePostData(
              setLoading,
              `seoReport/addFinalReport`,
              token,
              formData
            )
          }

          if (res?.data?.success) {
            swal("", "Report has been saved successfully", "success")
            handleSearchReport()
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  const isEditorEmpty = (value) => {
    if (!value) return true

    const stripped = value
      .replace(/<[^>]*>/g, "") // remove HTML tags
      .replace(/&nbsp;/g, "")
      .trim()

    return stripped.length === 0
  }

  const publishReport = () => {

    if (
      isEditorEmpty(reportSummary) ||
      isEditorEmpty(challenges) ||
      isEditorEmpty(keywordSummary) ||
      isEditorEmpty(nextSteps) || highlights.some(h => !h)
    ) {
      swal("", "Report Summary, Challenges, Keyword Summary, Next Steps and Highlights are required fields.", "warning")
      return
    }

    swal({
      title: "Are you sure?",
      text: `You want to Publish report for ${monthOptions[month - 1]}, ${year}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        try {
          const res = await fetchNodeData(
            setLoading,
            `seoReport/publishFinalReport/${reportId}`,
            token
          )

          if (res?.success) {
            swal("", "Final Report has been published successfully", "success")
            handleSearchReport()
          } else {
            swal(
              "",
              res?.response?.data?.message ||
              res.message ||
              "Something Went Wrong!",
              "warning"
            )
          }

          console.log(res)

          // console.log(res)
        } catch (error) {
          console.log(error, "Something Went Wrong")
          swal(
            "",
            error?.response?.data?.message ||
            error.message ||
            "Something Went Wrong!",
            "error"
          )
        }
      }
    })
  }

  /* ================= HELPERS ================= */

  const handleNegativeValue = (section, key, field, value) => {
    setOrdersPerformance(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        [field]: value,
        reason: value < 0 ? prev[key].reason : "",
      },
    }))
  }

  // Website Traffic comparison
  const calculateChange = (current, last) => {
    if (!current || !last || Number(last) === 0) {
      return { percentage: "", trend: "" }
    }

    const diff = ((current - last) / last) * 100
    return {
      percentage: Math.abs(diff).toFixed(2),
      trend: diff >= 0 ? "up" : "down",
    }
  }

  const updatePerformanceRow = (index, field, value) => {
    const updated = [...performanceComparison]
    updated[index][field] = value

    if (field === "current" || field === "last") {
      const { percentage, trend } = calculateChange(
        Number(updated[index].current),
        Number(updated[index].last)
      )
      updated[index].percentage = percentage
      updated[index].trend = trend
    }
    return updated[index]
    // setPerformanceComparison(updated)
  }

  const updateTraffic = (item, current = 0, previous = 0) => {
    const updated = { ...item }
    updated.current = current
    updated.last = previous

    if (current || previous) {
      const { percentage, trend } = calculateChange(Number(updated.current), Number(updated.last || 1))
      updated.percentage = updated.last ? percentage : "100.0"
      updated.trend = trend
    }
    return updated
  }
  // =============== FOR KEYWORDS ====================
  const transformKeywordData = (data) => { 
    const dates = data?.reverse()?.map(item => item.label)

    const keywordMap = {}

    data.forEach(item => {
      if (item.value !== "Create new +") {
        const keywords = JSON.parse(item?.keyword)

        keywords.forEach(k => {
          const name = k.keyword.trim()

          if (!keywordMap[name]) {
            keywordMap[name] = {}
          }

          keywordMap[name][item.label] = k.rank
        })
      }
    })

    return {
      dates,
      keywordRows: keywordMap
    }
  }

  const { dates, keywordRows } = useMemo(() => transformKeywordData(monthlyKeywordRecords), [monthlyKeywordRecords])
  /* ================= UI ================= */

  const yearsOptions = useMemo(() => getYearOptions(2015), [])

  const isPPC = useMemo(() => {
    const result = service?.value == "3"
    // setIsOrders(result)
    return result
  }, [service])

  const isSEO = useMemo(() => service?.value == "1", [service])

  return (
    <>
      {loading && <Loader />}
      <Card className="mb-4">
        <CardBody>
          <div>
            <div className="d-flex justify-content-between mb-4 pb-4 border-bottom">
              <h5 className="text-purple">{heading}</h5>

              <div>
                {isFinalReport && isPublished && (
                  <button
                    onClick={() => setPreviewModal(true)}
                    className=" btn text-white btn-success btn-label ms-3"
                  >
                    <i className="fas fa-eye me-2 icon-size label-icon"></i>
                    Preview Report
                  </button>
                )}

                {isFinalReport && !isPublished && reportId && !isEditingContent && (
                  <button
                    onClick={publishReport}
                    className=" btn text-white btn-primary btn-label ms-3"
                  >
                    <i className="fas fa-save me-2 icon-size label-icon"></i>
                    Final Publish
                  </button>
                )}

                {(reportDate?.value === monthDatesOptions[0].value ||
                  isFinalReport) &&
                  isCreated == "create" && (
                    <button
                      onClick={
                        isFinalReport
                          ? saveFinalReport
                          : handleSaveKeywordRanking
                      }
                      className=" btn text-white btn-save btn-label ms-3"
                    >
                      <i className="fas fa-plus me-2 icon-size label-icon"></i>
                      Save
                    </button>
                  )}
                <button
                  onClick={() => navigate(-1)}
                  className=" btn btn-red btn-label ms-3"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  Cancel
                </button>
              </div>
            </div>

            <form
              onSubmit={handleSearchReport}
              className="d-flex justify-content-between "
            >
              <div className="col-10">
                <div className="row">
                  <div className="col-3">
                    <Select
                      placeholder="Select Project"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={projectOptions}
                      onChange={e => {
                        setProject(e)
                        if (service)
                          setService(null)
                      }}
                      required
                    />
                  </div>

                  <div className="col-3">
                    <Select
                      placeholder="Services"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      options={project?.services?.filter(item => item.value == "1") || []}
                      onChange={(e) => setService(e)}
                      value={service || []}
                    // isMulti
                    // isDisabled
                    />
                  </div>

                  <div className="col-2">
                    <select
                      className="form-select"
                      value={month}
                      onChange={e => setMonth(e.target.value)}
                      required
                    >
                      <option value="">Month</option>
                      {monthOptions.map((month, key) => (
                        <option key={month} value={key + 1}>
                          {month}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-2">
                    <select
                      className="form-select "
                      value={year}
                      onChange={e => setYear(e.target.value)}
                      required
                    >
                      <option value="">Year</option>
                      {yearsOptions.map(year => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-2">
                    <Button
                      color="primary"
                      // onClick={() =>
                      //   setIsCreated(
                      //     month == "December" ? "notfound" : "create"
                      //   )
                      // }
                      className="btn-purple border-0"
                    >
                      <i className="fas fa-search me-1"></i> Search
                    </Button>
                  </div>
                </div>
              </div>

              <div className="col-2 d-flex justify-content-end ps-2">
                {isCreated == "create" && !isFinalReport && (
                  <Select
                    placeholder="Select Date"
                    className="basic-multi-select w-100"
                    classNamePrefix="select"
                    options={monthlyKeywordRecords}
                    value={reportDate}
                    onChange={e => setReportDate(e)}
                  />
                )}
              </div>
            </form>
          </div>
        </CardBody>
      </Card>

      {isCreated == "create" && (
        <>
          {isFinalReport && (
            <>
              {/* 1. REPORT SUMMARY */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="fw-semibold text-purple mb-3">
                    Report Summary
                  </h5>
                  <CKEditor
                    editor={ClassicEditor}
                    data={reportSummary}
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      if (!isEditingContent)
                        setIsEditingContent(true)
                      setReportSummary(data)
                    }}
                  />
                </CardBody>
              </Card>

              {/* KEY CHALLENGES */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="fw-semibold text-purple mb-3">
                    Key Challenges & Areas for Improvement
                  </h5>
                  <CKEditor
                    editor={ClassicEditor}
                    data={challenges}
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      if (!isEditingContent)
                        setIsEditingContent(true)
                      setChallenges(data)
                    }}
                  />
                </CardBody>
              </Card>

              {/* KEY HIGHLIGHTS */}
              <Card className="mb-4">
                <CardBody>
                  <h5 className="fw-semibold text-purple mb-3">
                    Key Highlights
                  </h5>

                  {highlights.map((item, i) => (
                    <Row key={i} className="mb-2">
                      <Col md={8}>
                        <Input
                          value={item}
                          placeholder="Enter Highlights Item"
                          onChange={e => {
                            const updated = [...highlights]
                            updated[i] = e.target.value
                            setHighlights(updated)
                            if (!isEditingContent)
                              setIsEditingContent(true)
                          }}
                        />
                      </Col>
                      <Col md={4}>
                        {i !== 0 && (
                          <Button
                            color="danger"
                            onClick={() =>
                              setHighlights(
                                highlights.filter((_, idx) => idx !== i)
                              )
                            }
                            className="me-3 btn-red border-0"
                          >
                            <i className="fas fa-trash"></i>
                          </Button>
                        )}

                        {i == highlights.length - 1 && (
                          <Button
                            color="primary"
                            onClick={() => setHighlights([...highlights, ""])}
                            className="btn-purple border-0"
                          >
                            <i className="fas fa-plus me-1"></i> Highlight
                          </Button>
                        )}
                      </Col>
                    </Row>
                  ))}
                </CardBody>
              </Card>
              {
                isSEO &&
                <>
                  {/* LOCAL SEO PERFORMANCE */}
                  <Card className="mb-4">
                    <CardBody>
                      <h5 className="fw-semibold text-purple mb-3">
                        Local SEO Performance
                      </h5>

                      <Table bordered>
                        <thead>
                          <tr>
                            <th>Google My Business</th>
                            <th className="col-1">Interaction</th>
                            <th className="col-1">Call</th>
                            <th className="col-1">Direction</th>
                            <th className="col-1">Click</th>
                            <th className="col-1">ScreenShot</th>
                            {/* <th></th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {localSeoPerformance?.map((row, i) => (
                            <tr key={i}>
                              <td>
                                <Input
                                  value={row.google_buisness}
                                  placeholder="Enter here.."
                                  onChange={e => {
                                    const updated = [...localSeoPerformance]
                                    updated[i].google_buisness = e.target.value
                                    setLocalSeoPerformance(updated)
                                  }}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  value={row.interactions}
                                  onChange={e => {
                                    const updated = [...localSeoPerformance]
                                    updated[i].interactions = e.target.value
                                    setLocalSeoPerformance(updated)
                                  }}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  value={row.calls}
                                  onChange={e => {
                                    const updated = [...localSeoPerformance]
                                    updated[i].calls = e.target.value
                                    setLocalSeoPerformance(updated)
                                  }}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  value={row.directions}
                                  onChange={e => {
                                    const updated = [...localSeoPerformance]
                                    updated[i].directions = e.target.value
                                    setLocalSeoPerformance(updated)
                                  }}
                                  disabled
                                />
                              </td>
                              <td>
                                <Input
                                  value={row.Click}
                                  onChange={e => {
                                    const updated = [...localSeoPerformance]
                                    updated[i].Click = e.target.value
                                    setLocalSeoPerformance(updated)
                                  }}
                                  disabled
                                />
                              </td>
                              <td className="d-flex gap-3 align-items-center">
                                {/* <input
                                      type="file"
                                      className="form-control"
                                      onChange={e =>
                                        handleUploadImage(e, setLocalSeoPerformance, i)
                                      }
                                    /> */}
                                {row.link ? (
                                  <img src={row.link} width={40} height={40} />
                                ) : null}
                              </td>
                              {/* <td className="col-2">
                                    {i !== 0 && (
                                      <Button
                                        color="danger"
                                        onClick={() =>
                                          setLocalSeoPerformance(
                                            localSeoPerformance.filter(
                                              (_, idx) => idx !== i
                                            )
                                          )
                                        }
                                        className="me-3 btn-red border-0"
                                      >
                                        <i className="fas fa-trash"></i>
                                      </Button>
                                    )}

                                    {i == localSeoPerformance.length - 1 && (
                                      <Button
                                        color="primary"
                                        onClick={() =>
                                          setLocalSeoPerformance([
                                            ...localSeoPerformance,
                                            {
                                              google_buisness: "",
                                              interactions: "",
                                              calls: "",
                                              directions: "",
                                              Click: "",
                                              link: null,
                                            },
                                          ])
                                        }
                                        className="btn-purple border-0"
                                      >
                                        <i className="fas fa-plus me-1"></i> New
                                      </Button>
                                    )}
                                  </td> */}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </>
              }
            </>
          )}

          {
            isFinalReport && (isPPC || isSEO) &&
            // {/* PERFORMANCE – ORDERS */ }
            <Card Card className="mb-4">
              <CardBody>
                <h5 className="fw-semibold text-purple mb-3 d-flex gap-4">
                  Performance – Primary Goal: Orders
                  <div className="form-switch form-switch-md">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isOrders}
                      onClick={e => {
                        setIsOrders(!e.target.checked)
                      }}
                    />
                  </div>
                </h5>
                {isOrders
                  ? Object.entries(ordersPerformance)?.filter(([key]) => key !== "id")?.map(([key, data]) => (
                    <Row key={key} className="mb-3">
                      <Col md={2}>
                        <h5 className="mb-0 pt-2">{data.title}</h5>
                      </Col>

                      <Col md={2}>
                        <Input
                          type="number"
                          placeholder="Value"
                          value={data.value}
                          onChange={e =>
                            handleNegativeValue(
                              "orders",
                              key,
                              "value",
                              e.target.value
                            )
                          }
                          disabled
                        />
                      </Col>

                      <Col md={4}>
                        <Input
                          placeholder="Subtitle"
                          value={data.subtitle}
                          onChange={e =>
                            setOrdersPerformance(prev => ({
                              ...prev,
                              [key]: {
                                ...prev[key],
                                subtitle: e.target.value,
                              },
                            }))
                          }
                          disabled
                        />
                      </Col>

                      {data.value < 0 && (
                        <Col md={4}>
                          <Input
                            placeholder="Reason for negative value"
                            value={data.reason}
                            onChange={e =>
                              setOrdersPerformance(prev => ({
                                ...prev,
                                [key]: {
                                  ...prev[key],
                                  reason: e.target.value,
                                },
                              }))
                            }
                            disabled
                          />
                        </Col>
                      )}
                    </Row>
                  ))
                  : null}
              </CardBody>
            </Card>
          }

          {/* PERFORMANCE BREAKDOWN */}
          {isPPC && (
            <Card className="mb-4">
              <CardBody>
                <h5 className="fw-semibold text-purple mb-3">
                  Performance Breakdown of All Campaigns
                </h5>

                <Table bordered>
                  <thead>
                    <tr>
                      <th>Campaign</th>
                      <th>Description</th>
                      <th className="col-3">ScreenShot</th>
                      {/* <th></th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {campaigns.map((row, i) => (
                      <tr key={i}>
                        <td>
                          <Input
                            value={row.title}
                            placeholder="Enter title"
                            onChange={e => {
                              const updated = [...campaigns]
                              updated[i].title = e.target.value
                              setCampaigns(updated)
                            }}
                            disabled
                          />
                        </td>
                        <td>
                          <Input
                            placeholder="Enter description"
                            value={row.description}
                            onChange={e => {
                              const updated = [...campaigns]
                              updated[i].description = e.target.value
                              setCampaigns(updated)
                            }}
                            disabled
                          />
                        </td>
                        <td className="d-flex gap-3 align-items-center">
                          {/* <Input
                            type="file"
                            onChange={e =>
                              handleUploadImage(e, setCampaigns, i)
                            }
                            disabled
                          /> */}
                          {row.link ? (
                            <img src={row.link} width={30} height={30} />
                          ) : null}
                        </td>
                        {/* <td className="col-2">
                              {i !== 0 && (
                                <Button
                                  color="danger"
                                  onClick={() =>
                                    setCampaigns(
                                      campaigns.filter((_, idx) => idx !== i)
                                    )
                                  }
                                  className="me-3 btn-red border-0"
                                >
                                  <i className="fas fa-trash"></i>
                                </Button>
                              )}

                              {i == campaigns.length - 1 && (
                                <Button
                                  color="primary"
                                  onClick={() =>
                                    setCampaigns([
                                      ...campaigns,
                                      {
                                        title: "",
                                        description: "",
                                        link: null,
                                      },
                                    ])
                                  }
                                  className="btn-purple border-0"
                                >
                                  <i className="fas fa-plus me-1"></i> Campaign
                                </Button>
                              )}
                            </td> */}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          )}

          {/* KEYWORD POSITION SUMMARY */}
          {
            isSEO &&
            <Card className="mb-4">
              <CardBody>
                <h5 className="fw-semibold text-purple mb-3">
                  Keyword Position {isFinalReport && "Summary"}
                </h5>
                {
                  !isFinalReport &&
                  <table className="table table-bordered mt-5">
                    <thead>
                      <tr>
                        <th className="fw-bold">Keywords</th>
                        {dates.map((date, i) => (
                          <th className="fw-bold" key={i}>{date}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {Object.keys(keywordRows).map((keyword, i) => (
                        <tr key={i}>
                          <td>{keyword}</td>

                          {dates.map((date, j) => (
                            <td key={j}>
                              {keywordRows[keyword][date] || "-"}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                }


                {isFinalReport && (
                  <CKEditor
                    editor={ClassicEditor}
                    data={keywordSummary}
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      setKeywordSummary(data)
                      if (!isEditingContent)
                        setIsEditingContent(true)
                    }}
                  />
                )}

                <h5 className="mt-5 mb-3">Keywords & Ranking</h5>
                {keywords.map((k, i) => (
                  <Row key={i} className="mb-2">
                    <Col md={6}>
                      <Input
                        placeholder="Keyword"
                        value={k.keyword}
                        disabled

                      // onChange={e => {
                      //   const updated = [...keywords]
                      //   updated[i].keyword = e.target.value
                      //   setKeywords(updated)
                      // }}
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        placeholder="Ranking"
                        type="number"
                        value={k.rank}
                        onChange={e => {
                          if (!isFinalReport) {
                            const updated = [...keywords]
                            updated[i].rank = e.target.value
                            setKeywords(updated)
                          }
                        }}
                        readOnly={isFinalReport || reportDate?.value !== monthDatesOptions[0].value}
                        disabled={isFinalReport}
                      />
                    </Col>
                    {/* <Col md={4}>
                      {i !== 0 && (
                        <Button
                          color="danger"
                          onClick={() =>
                            setKeywords(keywords.filter((_, idx) => idx !== i))
                          }
                          className="me-3 btn-red border-0"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      )}

                      {i == keywords.length - 1 && (
                        <Button
                          color="primary"
                          onClick={() =>
                            setKeywords([
                              ...keywords,
                              { keyword: "", rank: "" },
                            ])
                          }
                          className="btn-purple border-0"
                        >
                          <i className="fas fa-plus me-1"></i> Keyword
                        </Button>
                      )}
                    </Col> */}
                  </Row>
                ))}

                {
                  !keywords.length && <span className="text-secondary">No keyword available!</span>
                }

                <h5 className="mt-5 mb-3">Additional Keywords & Ranking
                  {
                    reportDate?.value === monthDatesOptions[0].value && !isFinalReport &&
                    <Button
                      color="primary"
                      onClick={() =>
                        setExtraKeywords([
                          ...extraKeywords,
                          { keyword: "", rank: "" },
                        ])
                      }
                      className="btn-purple border-0 ms-4 py-1"
                    >
                      <i className="fas fa-plus me-1"></i> Keyword
                    </Button>
                  }

                </h5>
                {extraKeywords.map((k, i) => (
                  <Row key={i} className="mb-2">
                    <Col md={6}>
                      <Input
                        placeholder="Keyword"
                        value={k.keyword}
                        onChange={e => {
                          const updated = [...extraKeywords]
                          updated[i].keyword = e.target.value
                          if (!e.target.value) {
                            updated[i].rank = ""
                          }
                          setExtraKeywords(updated)
                        }}
                        disabled={isFinalReport}
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        placeholder="Ranking"
                        type="number"
                        value={k.rank}
                        onChange={e => {
                          if (!isFinalReport) {
                            const updated = [...extraKeywords]
                            updated[i].rank = e.target.value
                            setExtraKeywords(updated)
                          }
                        }}
                        readOnly={isFinalReport || !k.keyword ||
                          reportDate?.value !== monthDatesOptions[0].value}
                        disabled={isFinalReport}

                      />
                    </Col>
                    <Col md={4}>
                      {
                        reportDate?.value === monthDatesOptions[0].value &&
                        <Button Button
                          color="danger"
                          onClick={() =>
                            setExtraKeywords(
                              extraKeywords.filter((_, idx) => idx !== i)
                            )
                          }
                          className="me-3 btn-red border-0"
                        >
                          <i className="fas fa-trash"></i>
                        </Button>
                      }
                    </Col>
                  </Row>
                ))}

                {
                  !extraKeywords.length && <span className="text-secondary">No keyword available!</span>
                }


              </CardBody>
            </Card>
          }

          {isFinalReport && (
            <>
              {
                isSEO &&
                <Card className="mb-4">
                  <CardBody>
                    <h5 className="fw-semibold text-purple mb-3">
                      Website Traffic Comparison from Last Month
                    </h5>

                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>Metric</th>
                          <th className="col-2">Current Month</th>
                          <th className="col-1">Last Month</th>
                          <th className="col-1">Change %</th>
                          <th className="col-1 text-center">Trend</th>
                          {/* <th></th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {performanceComparison.map((row, i) => (
                          <tr key={i}>
                            <td>
                              <Input
                                value={row.metric}
                                disabled={row.fixed}
                                onChange={e =>
                                  updatePerformanceRow(
                                    i,
                                    "metric",
                                    e.target.value
                                  )
                                }
                              />
                            </td>

                            <td>
                              <Input
                                type="text"
                                value={row.current}
                                onChange={e =>
                                  updatePerformanceRow(
                                    i,
                                    "current",
                                    e.target.value
                                  )
                                }
                                disabled
                              />
                            </td>

                            <td>
                              <Input
                                type="text"
                                value={row.last}
                                readOnly
                                onChange={e =>
                                  updatePerformanceRow(i, "last", e.target.value)
                                }
                                disabled
                              />
                            </td>

                            <td>
                              <Input value={row.percentage || "--"} disabled />
                            </td>

                            <td className="text-center fs-5">
                              {row.trend === "up" && (
                                <span style={{ color: "green" }}>↑</span>
                              )}
                              {row.trend === "down" && (
                                <span style={{ color: "red" }}>↓</span>
                              )}
                            </td>

                            {/* <td className="col-2">
                            {!row.fixed && (
                              <Button
                                color="danger"
                                onClick={() =>
                                  setPerformanceComparison(
                                    performanceComparison.filter(
                                      (_, idx) => idx !== i
                                    )
                                  )
                                }
                                className="me-3 btn-red border-0"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            )}

                            {i == performanceComparison.length - 1 && (
                              <Button
                                color="primary"
                                onClick={() =>
                                  setPerformanceComparison([
                                    ...performanceComparison,
                                    {
                                      metric: "",
                                      current: "",
                                      last: "0",
                                      percentage: "",
                                      trend: "",
                                      fixed: false,
                                    },
                                  ])
                                }
                                className="btn-purple border-0"
                              >
                                <i className="fas fa-plus me-1"></i> Metric
                              </Button>
                            )}
                          </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </CardBody>
                </Card>
              }

              {/* NEXT STEPS */}
              <Card>
                <CardBody>
                  <h5 className="fw-semibold text-purple mb-3">
                    Next Steps & Strategies for Next Month
                  </h5>
                  <CKEditor
                    editor={ClassicEditor}
                    data={nextSteps}
                    onReady={editor => {
                      // You can store the "editor" and use when it is needed.
                    }}
                    onChange={(event, editor) => {
                      const data = editor.getData()
                      setNextSteps(data)
                      if (!isEditingContent)
                        setIsEditingContent(true)
                    }}
                  />
                </CardBody>
              </Card>
            </>
          )}
        </>
      )
      }

      {
        isCreated == "notfound" && (
          <Card className="mb-4 text-center">
            <CardBody>
              <img src={NoImg} className="w-25 mb-4" />

              <div>
                <h5 className="mb-4">Oops! No Data found for selected items</h5>
                {
                  !isFinalReport &&
                  <Button
                    color="primary"
                    onClick={() => {
                      // if (keywords.length) {
                      //   swal("", "Please add keywords for selected project.", "warning");
                      //   return;
                      // }
                      setIsCreated("create")
                      setReportDate(monthDatesOptions[0])
                    }}
                    className="btn-purple border-0"
                  >
                    <i className="fas fa-plus me-1"></i> Add Ranking Now
                  </Button>
                }
              </div>
            </CardBody>
          </Card>
        )
      }

      {/* Approve Modal */}
      <SeoReportPreview
        previewModal={previewModal}
        setPreviewModal={setPreviewModal}
        reportSummary={finalReportData?.reportSummary}
        keywordSummary={finalReportData?.keywordSummary}
        challenges={finalReportData?.challenges}
        highlights={finalReportData?.highlights}
        ordersPerformance={finalReportData?.ordersPerformance}
        campaigns={finalReportData?.campaigns}
        localSeoPerformance={finalReportData?.localSeoPerformance}
        extraKeywords={extraKeywords}
        performanceComparison={finalReportData?.performanceComparison}
        nextSteps={finalReportData?.nextSteps || []}
        month={month}
        year={year}
        project={project}
        monthOptions={monthOptions}
        allMonthKeywords={allMonthKeywords}
        customerData={customerData}
      />
    </>
  )
}

export default SeoReport
